import { Popover } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { CheckboxFilter } from './CheckboxFilter';
import { IExpert } from '@/shared/IExpert';

export const CheckboxFilterRole = (props: {
  allExperts: IExpert[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const roleOptions = [
    { label: 'Reviewer', value: 'reviewer' },
    { label: 'Staff', value: 'staff' },
  ];

  const options = roleOptions.map((item) => ({
    label: item.label,
    value: item.value,
    count: props.allExperts?.reduce((count, expert: IExpert) => (expert.role === item.value) ? count + 1 : count, 0) ?? 0
  })).filter(option => option.count > 0); // Only show options that exist

  const hasSelection = props.value !== undefined && props.value.length > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Role" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxFilter
          hideLabel
          value={props.value}
          onChange={(v) => props.onSetFilter(v)}
          options={options} />
      </FilterPopoverContent>
    </Popover>
  );
};
